/**
 * @generated SignedSource<<fcd5868cf6e505d6f9d00064d54a1a03>>
 * @relayHash 127cb5587f2a92a32c9a887addd1d130
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c090c3adcd49e9b8d1327fa26dca86a9d8e82bf6747475b17f94ba52ad76e393

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type srcHelpCenterVirtualAgentSettingsQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
  isHideKbColumnEnabled: boolean;
  isJsmAIConfigEnabled: boolean;
  isTotalArticleCountEnabled: boolean;
  isVAOnHelpCenterGAEnabled: boolean;
};
export type srcHelpCenterVirtualAgentSettingsQuery$data = {
  readonly helpCenter?: {
    readonly helpCenterById: {
      readonly __typename: string;
      readonly message?: string | null | undefined;
      readonly virtualAgentEnabled?: boolean | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"settingsBreadcrumbsFragment" | "settingsVirtualAgentSettingsTabFragment">;
    } | null | undefined;
  } | null | undefined;
  readonly helpObjectStore_searchArticles?: {
    readonly " $fragmentSpreads": FragmentRefs<"settingsVirtualAgentLinkedArticlesFragment">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"settingsVirtualAgentSettingsTabMappedProjectsFragment">;
};
export type srcHelpCenterVirtualAgentSettingsQuery = {
  response: srcHelpCenterVirtualAgentSettingsQuery$data;
  variables: srcHelpCenterVirtualAgentSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHideKbColumnEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJsmAIConfigEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTotalArticleCountEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isVAOnHelpCenterGAEnabled"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "kind": "Variable",
  "name": "helpCenterAri",
  "variableName": "helpCenterAri"
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "virtualAgentEnabled"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v13 = [
  (v6/*: any*/),
  (v8/*: any*/),
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "kind": "InlineFragment",
  "selections": (v15/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v17 = [
  (v6/*: any*/),
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "helpCenterARI",
        "variableName": "helpCenterAri"
      },
      {
        "kind": "Literal",
        "name": "helpCenterId",
        "value": ""
      },
      {
        "kind": "Literal",
        "name": "helpCenterMappingStatus",
        "value": "LINKED"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "srcHelpCenterVirtualAgentSettingsQuery",
    "selections": [
      {
        "condition": "isJsmAIConfigEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "HelpCenterQueryApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
              {
                "args": (v9/*: any*/),
                "kind": "LinkedField",
                "name": "helpCenterById",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "settingsVirtualAgentSettingsTabFragment"
                      },
                      (v11/*: any*/)
                    ],
                    "type": "HelpCenter"
                  },
                  (v12/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "settingsBreadcrumbsFragment"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isTotalArticleCountEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v13/*: any*/),
            "kind": "LinkedField",
            "name": "helpObjectStore_searchArticles",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "settingsVirtualAgentLinkedArticlesFragment"
              }
            ]
          }
        ]
      },
      {
        "condition": "isVAOnHelpCenterGAEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v6/*: any*/),
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "isHideKbColumnEnabled",
                "variableName": "isHideKbColumnEnabled"
              },
              {
                "kind": "Variable",
                "name": "isVAOnHelpCenterGAEnabled",
                "variableName": "isVAOnHelpCenterGAEnabled"
              }
            ],
            "kind": "FragmentSpread",
            "name": "settingsVirtualAgentSettingsTabMappedProjectsFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "srcHelpCenterVirtualAgentSettingsQuery",
    "selections": [
      {
        "condition": "isJsmAIConfigEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "HelpCenterQueryApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
              {
                "args": (v9/*: any*/),
                "kind": "LinkedField",
                "name": "helpCenterById",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      {
                        "concreteType": "HelpCenterName",
                        "kind": "LinkedField",
                        "name": "name",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "default"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "slug"
                      }
                    ],
                    "type": "HelpCenter"
                  },
                  (v12/*: any*/),
                  (v16/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isTotalArticleCountEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v13/*: any*/),
            "kind": "LinkedField",
            "name": "helpObjectStore_searchArticles",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHelpObjectStoreArticleSearchResponse"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "totalCount"
                  }
                ],
                "type": "HelpObjectStoreArticleSearchResults"
              }
            ]
          }
        ]
      },
      {
        "condition": "isVAOnHelpCenterGAEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "condition": "isVAOnHelpCenterGAEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "args": (v17/*: any*/),
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "jiraProjectsMappedToHelpCenter",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraProjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "small"
                                  }
                                ]
                              },
                              {
                                "condition": "isHideKbColumnEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                  {
                                    "args": (v7/*: any*/),
                                    "kind": "LinkedField",
                                    "name": "knowledgeBaseArticlesCount",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "count"
                                          }
                                        ],
                                        "type": "KnowledgeBaseArticleCountSource"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "virtualAgentConfiguration",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isAiResponsesEnabled"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "liveIntentsCount"
                                      }
                                    ],
                                    "type": "VirtualAgentConfiguration"
                                  },
                                  (v16/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v15/*: any*/),
                                    "type": "VirtualAgentQueryError"
                                  }
                                ]
                              },
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "args": (v17/*: any*/),
                    "filters": [
                      "cloudId",
                      "filter"
                    ],
                    "handle": "connection",
                    "key": "projectBreakdownTableMappedProjectsFragment_jiraProjectsMappedToHelpCenter",
                    "kind": "LinkedHandle",
                    "name": "jiraProjectsMappedToHelpCenter"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c090c3adcd49e9b8d1327fa26dca86a9d8e82bf6747475b17f94ba52ad76e393",
    "metadata": {},
    "name": "srcHelpCenterVirtualAgentSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "848394ca7a90b3bb8cc25854972756d0";

export default node;
